import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AntAutoComplete from 'antd/lib/auto-complete';
import './style';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  ...AntAutoComplete.propTypes,
};

class AutoComplete extends React.Component {
  render() {
    const { className, children, ...rest } = this.props;
    const computedClassName = classNames('bsa-auto-complete', className);
    return (
      <AntAutoComplete
        className={computedClassName}
        {...rest}
      >
        {children}
      </AntAutoComplete>
    );
  }
}

AutoComplete.propTypes = propTypes;
AutoComplete.defaultProps = AntAutoComplete.defaultProps;
AutoComplete.Option = AntAutoComplete.Option;
AutoComplete.OptGroup = AntAutoComplete.OptGroup;
export default AutoComplete;
